module.exports = __webpack_public_path__ + "img/homeParralex.5b7e3bbe.webp";